import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Team from './components/Team';
import Directors from './components/Directors';
import OpenPositions from './components/OpenPositions';
import Career from './components/Career';
import Connect from './components/Connect';
import Footer from './components/Footer';
import FloatingButton from './components/FloatingButton';
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import NeuralSystem from './components/NeuralSystem';
import OurWorks from './components/OurWorks';
import Services from './components/Services';
import Getaquote from './components/GetAQuote';
import FAQ from './pages/FAQ'; // Import the FAQ component
import Blogs from './pages/Blogs';
import Gallery from './pages/Gallery';
import SawoodPortfolio from './pages/sawoodPortfolio';
import IqlaasPortfolio from './pages/iqlaasPortfolio';
import MassoodhPortfolio from './pages/massoodhPortfolio';
import RoshanPortfolioo from './pages/roshanPortfolio';
import RiyaPortfolio from './pages/riyaPortfolio';
import AymanPortfolio from './pages/aymanPortfolio';
import AbdulPortfolio from './pages/abdulPortfolio';
import EisaPortfolio from './pages/eisaPortfolio';
import RouteScrollToTop from './components/RouteScrollToTop';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import { Navigate } from 'react-router-dom';

function HomepageSections() {
  const location = useLocation();
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          smooth: true,
          offset: -70,
          duration: 500,
        });
      }, 100); // Wait for DOM to render
    }
  }, [location]);
  return (
    <>
      <Hero />
      <About />
      <NeuralSystem />
      <Products />
      <OurWorks />
      <Services />
      <Getaquote />
      <Team />
      <Directors />
      <OpenPositions />
      <Career />
      <FAQ />
      <Connect />
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });

    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return loading ? (
    <Loader />
  ) : (
    <Router>
      <RouteScrollToTop />
      <motion.div
        className="bg-dark text-white font-sans min-h-screen"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Navbar />
        <Routes>
          <Route path="/" element={<HomepageSections />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/Terms" element={<Navigate to="/terms" replace />} />
          <Route path="/Privacy" element={<Navigate to="/privacy" replace />} />
          <Route path="/sawoodPortfolio" element={<SawoodPortfolio />} />
          <Route path="/iqlaasPortfolio" element={<IqlaasPortfolio />} />
          <Route path="/massoodhPortfolio" element={<MassoodhPortfolio />} />
          <Route path="/roshanPortfolio" element={<RoshanPortfolioo />} />
          <Route path="/riyaPortfolio" element={<RiyaPortfolio />} />
          <Route path="/aymanPortfolio" element={<AymanPortfolio />} />
          <Route path="/abdulPortfolio" element={<AbdulPortfolio />} />
          
          <Route path="/eisaPortfolio" element={<EisaPortfolio />} />
        </Routes>
        <Footer />
        <FloatingButton />
        <ScrollToTop />
      </motion.div>
    </Router>
  );
}

export default App;
